import type { RouteRecordRaw } from "vue-router";

export const collectionsRoutes: RouteRecordRaw[] = [
  // Static routes must come before dynamic :id
  {
    path: "/collections/how_to",
    name: "collections-how-to",
    component: () => import("./how_to.vue"),
  },
  {
    path: "/collections/:id",
    component: () => import("./CollectionLayout.vue"),
    children: [
      {
        path: "",
        name: "collections-show",
        component: () => import("./[id]/CollectionDetailPage.vue"),
      },
    ],
  },
];
